import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon } from 'lucide-react';
import { trackRegistroCompletado } from '../utils/metaPixel';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/miKeNXnKoUZ4pNJ3m9H5UE/PNG-website-file-dark-Transparent-background.png';
const WHATSAPP_URL = 'https://go.wha.link/aM5v1a';
const REDIRECT_SECONDS = 3;
export function ThankYou() {
  useEffect(() => {
    const timer = setTimeout(() => {
      trackRegistroCompletado();
      window.location.href = WHATSAPP_URL;
    }, REDIRECT_SECONDS * 1000);
    return () => clearTimeout(timer);
  }, []);
  return <div className="w-full min-h-screen bg-navy font-inter flex flex-col items-center justify-center px-4" data-id="element-107">
      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.5
    }} className="max-w-md w-full text-center" data-id="element-108">
        <img src={LOGO_URL} alt="Start Launching Creatives" className="w-40 md:w-52 mx-auto mb-8" data-id="element-109" />

        <motion.div initial={{
        scale: 0
      }} animate={{
        scale: 1
      }} transition={{
        delay: 0.2,
        type: 'spring',
        stiffness: 200
      }} data-id="element-110">
          <CheckCircleIcon className="w-20 h-20 text-[#25D366] mx-auto mb-6" data-id="element-111" />
        </motion.div>

        <h1 className="font-oswald text-3xl md:text-4xl font-bold text-white uppercase mb-4" data-id="element-112">
          Gracias por registrarte
        </h1>

        <p className="text-white font-inter text-base md:text-lg leading-relaxed mb-8" data-id="element-113">
          Serás redirigido al grupo de WhatsApp en {REDIRECT_SECONDS} segundos
        </p>

        {/* Progress bar */}
        <div className="w-full h-3 bg-navy-card border border-navy-border rounded-full overflow-hidden mb-8" data-id="element-114">
          <motion.div initial={{
          width: '0%'
        }} animate={{
          width: '100%'
        }} transition={{
          duration: REDIRECT_SECONDS,
          ease: 'linear'
        }} className="h-full bg-[#25D366] rounded-full" data-id="element-115" />
        </div>

        <a href={WHATSAPP_URL} className="inline-flex items-center justify-center gap-2 text-[#25D366] font-inter text-sm underline underline-offset-4 hover:text-[#20bd5a] transition-colors" data-id="element-116">
          Si no eres redirigido, haz clic aquí
        </a>
      </motion.div>
    </div>;
}